import React, { useState, useEffect } from "react";
import requiredImg from "../../../Images/sp.gif";
import { DisplayMsg } from "../../../services/toastService";
import { setUrl } from "../../../handlers";


const TrainingLink = (props) => {
  const [Errors, setErrors] = useState({
    Invitee: "",
    Email: "",
    Trainer: "",
    Event: "",
  });
  const [LinkDetail, setLinkDetail] = useState({
    Email: "",
    Trainer: "",
    Event: "",
    Mark: true,
  });

  let check = true;

  useEffect(() => {
    setLinkDetail((trainingData) => ({
      ...trainingData,
      Email: props.data.TrainingEmail,
      Trainer: props.data.Trainer,
    }));
  }, []);

  const TrainingPopup = () => {
    props.CallBackLink(false, "");
  };

  const AddNewTraining = (e, type) => {
    const { name } = e.target;
    const { value } = e.target;

    if (type === "checkbox") {
      setLinkDetail((trainingData) => ({
        ...trainingData,
        Mark: e.target.checked,
      }));
    } else {
      ValidateField(name, value);
      setLinkDetail((trainingData) => ({
        ...trainingData,
        [name]: value,
      }));
    }
  };

  const ValidateField = (fieldName, fieldVal) => {
    if (fieldVal.length < 1) {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: "Required",
      }));
    } else {
      setErrors((errorInfo) => ({
        ...errorInfo,
        [fieldName]: "",
      }));
      check = true;
    }
  };

  const VerifyFields = () => {
    if (LinkDetail.Event === "") {
      setErrors((errorInfo) => ({
        ...errorInfo,
        Event: "Required",
      }));
      check = false;
    } else {
      setErrors((errorInfo) => ({
        ...errorInfo,
        Event: "",
      }));
    }
  };

  const CreateLink = () => {
    let createdLink = "";
    VerifyFields();
    if (check) {
      document.getElementById("loader").style.display = "block";
      const filter = `&uuid=${props.data.TrainerUuid}&trainer=${props.data.Trainer}&flag=${LinkDetail.Mark}&event=${LinkDetail.Event}`;
      // await
      fetch(setUrl("calendly", "link", true) + filter)
        .then((response) => response.json())
        .then((json) => {
          if (json.status === true) {
            if (json.filteredResponse != null) {
              if (LinkDetail.Mark) {
                createdLink = `${json.filteredResponse.booking_url}?name=${props.data.Invitee}&email=${props.data.InviteeEmail}`;
              } else {
                createdLink = `${json.filteredResponse.scheduling_url}?name=${props.data.Invitee}&email=${props.data.InviteeEmail}`;
              }
            }
            if (json.returnResponse != null) {
              let result = JSON.parse(json.returnResponse);
              result = result.responseContent.resource;
              createdLink = `${result.booking_url}?name=${props.data.Invitee}&email=${props.data.InviteeEmail}`;
            }
            DisplayMsg("1", "Successfully Link Created");
            props.CallBackLink(false, createdLink);
          } else {
            DisplayMsg("2", json.Message);
          }
        })
        .catch((error) => {
          DisplayMsg("2", "Link Creation Failed");
        });
    }
  };
  return (
    <div className="overlay">
      <div className="popup">
        <div className="popup__header">
          <h3> Generate Training Link </h3>
          <span
            className="close"
            role="button"
            onClick={() => TrainingPopup(false)}
          >
            ×
          </span>
        </div>
        <div className="content">
          <div className="popup__body">
            <div className="align-items-center flex flex-column w-full">
              <div className="col-md-6 col-sm-6 mt-2">
                <div className="field-container mb-0">
                  <label className="field-placeholder">
                    Invitee Email :{" "}
                    <img
                      alt="Required"
                      src={requiredImg}
                      className="redboxRequired"
                    />
                  </label>
                  <input
                    type="text"
                    name="Email"
                    className="field-input"
                    value={props.data.InviteeEmail}
                    disabled
                  />
                </div>
                <label className="requiredtext mt-0">{Errors.Email}</label>
              </div>

              <div className="col-md-6 col-sm-6 mt-2">
                <div className="field-container mb-0">
                  <label className="field-placeholder">
                    Trainer :{" "}
                    <img
                      alt="Required"
                      src={requiredImg}
                      className="redboxRequired"
                    />
                  </label>
                  <input
                    type="text"
                    name="Trainer"
                    className="field-input"
                    value={props.data.Trainer}
                    disabled
                  />
                </div>
                <label className="requiredtext mt-0">{Errors.Trainer}</label>
              </div>

              <div className="col-md-6 col-sm-6 mt-2">
                <div className="field-container mb-0">
                  <label className="field-placeholder">
                    Event :{" "}
                    <img
                      alt="Required"
                      src={requiredImg}
                      className="redboxRequired"
                    />
                  </label>
                  <select
                    className="field-input"
                    name="Event"
                    value={LinkDetail.Event}
                    onChange={(e) => AddNewTraining(e)}
                  >
                    {props.data.Events?.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
                <label className="requiredtext mt-0">{Errors.Event}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-6 text-end">
                <div className="input-checkbox m-3">
                  <label className="input-checkbox-label">
                    Mark Link Single use
                  </label>
                  <input
                    type="checkbox"
                    className="field-input ml-1"
                    name="Mark"
                    onChange={(e) => AddNewTraining(e, "checkbox")}
                  />
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-12 col-sm-12">
                <label>&nbsp;</label>
                <input
                  type="button"
                  className="btnLinkGreen ClosePopup"
                  onClick={() => CreateLink()}
                  value="Create Link"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingLink;
